import React, { Component } from 'react'
import { graphql } from 'gatsby'
import Seo from '../components/seo'
import PropertyHeroBanner from '../components/cards/property-hero-banner'
import PropertyFeature from '../components/cards/property-feature'
import Property from '../components/cards/property'
import Slogan from '../components/slogan'
import SearchOverlay from '../components/search-overlay'
import NoResultsFound from '../components/no-results-found'

class LeaseCommercialPage extends Component {

  state = {
    display: this.props.data.properties || []
  }

  render() {

    let x = 0
    let y = 0
    let canSearch = true
    let label = 'For Lease'
    let postType='rental'
    let propertyType='commercial'
    let { display } = this.state
    const { properties, wp } = this.props.data

    return (
      <>
        <Seo title="Commercial Leasing Agents Geelong - Gartland" bodyClass='buy dark-theme' description="Expert commercial leasing agents in Geelong. Gartland helps landlords and tenants find the perfect commercial space. Contact us for professional advice." />
        <SearchOverlay canSearch={canSearch} list={properties || []} set={list => this.setState({ display: list })} type="lease-commercial" postType={postType} propertyType={propertyType} />
        <section className="properties">
          <div className="properties__inner">
            <div className="properties__content">
              <div className="properties__details">

                { display.edges.length > 0 && display.edges.map((el, i) => {

                    x += 1
                    y += 1

                    if (i === 0) {
                      return (
                        <div className='properties__hero-banner' key={i}>
                          <PropertyHeroBanner label={label} postType={postType} propertyType={propertyType} {...el.node} />
                        </div>
                      )
                    }

                    if( x % 8 === 0 ) {
                      x = 2;
                    }

                    if( x > 1 && x <= 3 && i > 0) {

                      return (
                        <>
                          <div className={`properties__feature ${x === 3 ? 'last' : '' }`}>
                            <PropertyFeature label={label} color='#E7E5E1' postType={postType} propertyType={propertyType} {...el.node} />
                          </div>
                        </>
                      )

                    } else {
                      return (
                        <>
                          <Property postType={postType} propertyType={propertyType} {...el.node} position={x === 7 ? 'last' : '' } />
                          { y === 7 ? <Slogan {...wp.siteSettings.acf.propertiesCommercialSlogan} /> : ''}
                        </>
                      )
                    }

                })}
                { display.edges.length === 0 &&
                  <NoResultsFound title={`No results found`} content='<p>No results at this time. Please refine your search.</p>' />
                }
              </div>
            </div>
          </div>
        </section>
      </>
    )
  }
}

export default LeaseCommercialPage

export const buyQuery = graphql`
  query {
    site {
      buildTime
    }
    properties: allWpProperty(
      filter: { propertyMeta: {isLeased: {ne: true}, class: {eq: "Commercial"}, status: {eq: "listing"}, commercialListingType: {in: ["lease", "both"]}}},
      sort: { date: DESC }
    )
    {
      edges {
        node {
          id
          slug
          title
          date
          propertyMeta {
            id
            address {
              suburb {
                postcode
              }
            }
            addressVisibility
            heading
            commercialListingType
            available
            carports
            garages
            openSpaces
            bed
            bath
            landAreaValue
            landAreaUnits
            floorAreaValue
            floorAreaUnits
            displayPrice
            displayAddress
            latitude
            longitude
            description
            class
            type
            zoning
            status
            searchPrice
            isLeased
          }
          images {
            url
            thumb_1024
            thumb_180
          }
        }
      }
    }
    wp {
      siteSettings {
        acf {
          propertiesCommercialSlogan {
            title
            content
            link
          }
        }
      }
    }
  }
`
